import React from "react";
import { Box, Typography } from "@mui/material";
import "./Newhome.css";
import { useLanguage } from "../../../utils/languageContext";

const Moredetailsfaq = () => {
  const { t } = useLanguage();

  // Build FAQ array dynamically from translation keys
  const faqs = [
    // Q1 – simple string answer
    {
      q: t("homepage.morefaq.q1"),
      a: t("homepage.morefaq.a1"),
    },
    // Q2 – simple string answer
    {
      q: t("homepage.morefaq.q2"),
      a: t("homepage.morefaq.a2"),
    },
    // Q3 – array answer
    {
      q: t("homepage.morefaq.q3"),
      a: [
        t("homepage.morefaq.a3_intro"),
        t("homepage.morefaq.a3_b1"),
        t("homepage.morefaq.a3_b2"),
        t("homepage.morefaq.a3_b3"),
        t("homepage.morefaq.a3_b4"),
        t("homepage.morefaq.a3_b5"),
      ],
    },
    // Q4 – array answer
    {
      q: t("homepage.morefaq.q4"),
      a: [
        t("homepage.morefaq.a4_intro"),
        t("homepage.morefaq.a4_b1"),
      ],
    },
    // Q5 – array answer
    {
      q: t("homepage.morefaq.q5"),
      a: [t("homepage.morefaq.a5_b1")],
    },
    // Q6 – simple string answer
    {
      q: t("homepage.morefaq.q6"),
      a: t("homepage.morefaq.a6"),
    },
    // Q7 – array answer
    {
      q: t("homepage.morefaq.q7"),
      a: [
        t("homepage.morefaq.a7_intro"),
        t("homepage.morefaq.a7_b1"),
        t("homepage.morefaq.a7_b2"),
        t("homepage.morefaq.a7_b3"),
      ],
    },
    // Q8 – object with title + steps
    {
      q: t("homepage.morefaq.q8"),
      a: {
        title: t("homepage.morefaq.a8_title"),
        steps: [
          t("homepage.morefaq.a8_s1"),
          t("homepage.morefaq.a8_s2"),
          t("homepage.morefaq.a8_s3"),
        ],
      },
    },
    // Q9 – object with title + steps
    {
      q: t("homepage.morefaq.q9"),
      a: {
        title: t("homepage.morefaq.a9_title"),
        steps: [
          t("homepage.morefaq.a9_s1"),
          t("homepage.morefaq.a9_s2"),
          t("homepage.morefaq.a9_s3"),
          t("homepage.morefaq.a9_s4"),
          t("homepage.morefaq.a9_s5"),
        ],
      },
    },
    // Q10 – object with steps + bulletsTitle + bullets + footer
    {
      q: t("homepage.morefaq.q10"),
      a: {
        steps: [
          t("homepage.morefaq.a10_s1"),
          t("homepage.morefaq.a10_s2"),
        ],
        bulletsTitle: t("homepage.morefaq.a10_bulletsTitle"),
        bullets: [
          t("homepage.morefaq.a10_b1"),
          t("homepage.morefaq.a10_b2"),
          t("homepage.morefaq.a10_b3"),
          t("homepage.morefaq.a10_b4"),
        ],
        footer: t("homepage.morefaq.a10_footer"),
      },
    },
    // Q11 – array answer
    {
      q: t("homepage.morefaq.q11"),
      a: [
        t("homepage.morefaq.a11_intro"),
        t("homepage.morefaq.a11_b1"),
        t("homepage.morefaq.a11_b2"),
        t("homepage.morefaq.a11_b3"),
        t("homepage.morefaq.a11_b4"),
        t("homepage.morefaq.a11_b5"),
        t("homepage.morefaq.a11_b6"),
      ],
    },
    // Q12 – object with bullets + footer
    {
      q: t("homepage.morefaq.q12"),
      a: {
        bullets: [
          t("homepage.morefaq.a12_b1"),
          t("homepage.morefaq.a12_b2"),
        ],
        footer: t("homepage.morefaq.a12_footer"),
      },
    },
    // Q13 – array answer
    {
      q: t("homepage.morefaq.q13"),
      a: [
        t("homepage.morefaq.a13_intro"),
        t("homepage.morefaq.a13_b1"),
        t("homepage.morefaq.a13_b2"),
      ],
    },
    // Q14 – object with bulletsTitle + bullets + footer
    {
      q: t("homepage.morefaq.q14"),
      a: {
        bulletsTitle: t("homepage.morefaq.a14_bulletsTitle"),
        bullets: [
          t("homepage.morefaq.a14_b1"),
          t("homepage.morefaq.a14_b2"),
          t("homepage.morefaq.a14_b3"),
          t("homepage.morefaq.a14_b4"),
          t("homepage.morefaq.a14_b5"),
          t("homepage.morefaq.a14_b6"),
        ],
        footer: t("homepage.morefaq.a14_footer"),
      },
    },
    // Q15 – simple string answer
    {
      q: t("homepage.morefaq.q15"),
      a: t("homepage.morefaq.a15"),
    },
    // Q16 – simple string answer
    {
      q: t("homepage.morefaq.q16"),
      a: t("homepage.morefaq.a16"),
    },
    // // Q17 – object with bulletsTitle + bullets + footer
    // {
    //   q: t("homepage.morefaq.q17"),
    //   a: {
    //     bulletsTitle: t("homepage.morefaq.a17_bulletsTitle"),
    //     bullets: [
    //       t("homepage.morefaq.a17_b1"),
    //       t("homepage.morefaq.a17_b2"),
    //       t("homepage.morefaq.a17_b3"),
    //     ],
    //     footer: t("homepage.morefaq.a17_footer"),
    //   },
    // },
    // // Q18 – object with bulletsTitle + bullets
    // {
    //   q: t("homepage.morefaq.q18"),
    //   a: {
    //     bulletsTitle: t("homepage.morefaq.a18_bulletsTitle"),
    //     bullets: [
    //       t("homepage.morefaq.a18_b1"),
    //       t("homepage.morefaq.a18_b2"),
    //       t("homepage.morefaq.a18_b3"),
    //     ],
    //   },
    // },
    // // Q19 – object with bullets only
    // {
    //   q: t("homepage.morefaq.q19"),
    //   a: {
    //     bullets: [
    //       t("homepage.morefaq.a19_b1"),
    //       t("homepage.morefaq.a19_b2"),
    //       t("homepage.morefaq.a19_b3"),
    //       t("homepage.morefaq.a19_b4"),
    //       t("homepage.morefaq.a19_b5"),
    //       t("homepage.morefaq.a19_b6"),
    //       t("homepage.morefaq.a19_b7"),
    //       t("homepage.morefaq.a19_b8"),
    //     ],
    //   },
    // },
    // // Q20 – simple string answer
    // {
    //   q: t("homepage.morefaq.q20"),
    //   a: t("homepage.morefaq.a20"),
    // },
    // // Q21 – object with bullets only
    // {
    //   q: t("homepage.morefaq.q21"),
    //   a: {
    //     bullets: [
    //       t("homepage.morefaq.a21_b1"),
    //       t("homepage.morefaq.a21_b2"),
    //       t("homepage.morefaq.a21_b3"),
    //       t("homepage.morefaq.a21_b4"),
    //     ],
    //   },
    // },
    // // Q22 – object with bullets only
    // {
    //   q: t("homepage.morefaq.q22"),
    //   a: {
    //     bullets: [
    //       t("homepage.morefaq.a22_b1"),
    //       t("homepage.morefaq.a22_b2"),
    //       t("homepage.morefaq.a22_b3"),
    //       t("homepage.morefaq.a22_b4"),
    //     ],
    //   },
    // },
    // // Q23 – object with bullets only
    // {
    //   q: t("homepage.morefaq.q23"),
    //   a: {
    //     bullets: [
    //       t("homepage.morefaq.a23_b1"),
    //       t("homepage.morefaq.a23_b2"),
    //       t("homepage.morefaq.a23_b3"),
    //       t("homepage.morefaq.a23_b4"),
    //     ],
    //   },
    // },
    // // Q24 – object with bulletsTitle + bullets
    // {
    //   q: t("homepage.morefaq.q24"),
    //   a: {
    //     bulletsTitle: t("homepage.morefaq.a24_bulletsTitle"),
    //     bullets: [
    //       t("homepage.morefaq.a24_b1"),
    //       t("homepage.morefaq.a24_b2"),
    //       t("homepage.morefaq.a24_b3"),
    //       t("homepage.morefaq.a24_b4"),
    //       t("homepage.morefaq.a24_b5"),
    //     ],
    //   },
    // },
    // // Q25 – object with bulletsTitle + bullets
    // {
    //   q: t("homepage.morefaq.q25"),
    //   a: {
    //     bulletsTitle: t("homepage.morefaq.a25_bulletsTitle"),
    //     bullets: [
    //       t("homepage.morefaq.a25_b1"),
    //       t("homepage.morefaq.a25_b2"),
    //       t("homepage.morefaq.a25_b3"),
    //       t("homepage.morefaq.a25_b4"),
    //     ],
    //   },
    // },
  ];

  return (
    <Box className="morefaq-root">
      {faqs.map((item, index) => (
        <Box key={index} className="faq-item">
          {/* QUESTION */}
          <Typography className="faq-question">
            {index + 1}. {item.q}
          </Typography>

          {/* ANSWER */}
          <Box className="morefaq-answer">
            {/* ✅ STRING */}
            {typeof item.a === "string" && (
              <Typography className="faq-text">{item.a}</Typography>
            )}

            {/* ✅ ARRAY (first item is intro text, rest are bullet items) */}
            {Array.isArray(item.a) && (
              <>
                <Typography className="faq-desc">{item.a[0]}</Typography>
                {item.a.length > 1 && (
                  <ul className="faq-list">
                    {item.a.slice(1).map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                )}
              </>
            )}

            {/* ✅ OBJECT (handles all sub-types) */}
            {typeof item.a === "object" && !Array.isArray(item.a) && (
              <>
                {/* 🔹 Title */}
                {item.a.title && (
                  <Typography className="faq-desc">{item.a.title}</Typography>
                )}

                {/* 🔹 Steps (ordered list) */}
                {item.a.steps && (
                  <ol className="faq-list">
                    {item.a.steps.map((step, i) => (
                      <li key={i}>{step}</li>
                    ))}
                  </ol>
                )}

                {/* 🔹 Bullet Title */}
                {item.a.bulletsTitle && (
                  <Typography className="faq-desc">
                    {item.a.bulletsTitle}
                  </Typography>
                )}

                {/* 🔹 Bullets (unordered list) */}
                {item.a.bullets && (
                  <ul className="faq-list">
                    {item.a.bullets.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                )}

                {/* 🔹 Footer */}
                {item.a.footer && (
                  <Typography className="faq-text">{item.a.footer}</Typography>
                )}
              </>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default Moredetailsfaq;
